import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PracticeLocationOption } from '../handle-cpx-modal/select-practice-location/select-practice-location.component';

/**
 * Sélection de l'activité Pro Santé Connect (stratégie REST).
 * Reprend la coque et le formulaire de la sélection du lieu d'exercice de HandleCpxModalComponent (stratégie websocket).
 */
@Component({
  selector: 'app-edc-choix-activite',
  templateUrl: './edc-choix-activite.component.html',
  styleUrls: ['../modal.fragment.scss']
})
export class EdcChoixActiviteComponent implements OnInit {
  @Input() public activities: any[] = [];
  @Output() public closeEmitter = new EventEmitter<any>();

  public practiceLocations: Array<PracticeLocationOption> = [];

  ngOnInit(): void {
    this.practiceLocations = (this.activities ?? []).map((activity, index) => {
      const libelle = activity.raisonSocialeSite
        ? `${activity.raisonSocialeSite} (${activity.codeSecteurDactivite})`
        : activity.codeSecteurDactivite;
      return {
        id: index.toString(),
        libelle: libelle || 'Activité sans nom'
      };
    });
  }

  public validate(selectedId: string): void {
    this.closeEmitter.emit(this.activities[Number(selectedId)]);
  }

  public close(): void {
    this.closeEmitter.emit();
  }
}
